import { Routes } from '@angular/router';

// Public routes
export const WEB_LAYOUT_ROUTES: Routes = [
  {
    path: 'web-layout',
    loadChildren: () => import('../../modules/web-layout/web-layout.module').then(m => m.WebLayoutModule)
  }
];
